// @flow

import React, { Component, Fragment } from "react";
import Checkbox from "@material-ui/core/Checkbox";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../types/GeneralTypes";

const styles = (theme: DictionaryType): DictionaryType => ({
  root: {
    color: theme.palette.primary.main,
    "&$checked": {
      color: theme.palette.primary.main
    }
  },
  checked: {},
  invalid: {
    color: theme.palette.error.main,
    "&$invalidChecked": {
      color: theme.palette.error.main
    }
  },
  invalidChecked: {}
});

type SingleCheckBoxClassesType = {
  root: DictionaryType,
  checked: DictionaryType,
  invalid: DictionaryType,
  invalidChecked: DictionaryType
};

type SingleCheckBoxPropsType = {
  classes: SingleCheckBoxClassesType,
  name: string,
  value: boolean,
  onChange: Function,
  label?: string,
  isInvalid?: boolean,
  tooltip?: string,
  isIndeter?: boolean,
  labelPlace?: string
};

class SingleCheckBox extends Component<SingleCheckBoxPropsType, *> {
  render(): * {
    const classes = this.props.classes;
    const Wrapper = this.props.tooltip ? Tooltip : Fragment;
    const isString =
      typeof this.props.label == "string" || this.props.label instanceof String;

    const CheckNode = (
      <Checkbox
        value="true"
        name={this.props.name}
        checked={this.props.value}
        classes={{
          root: this.props.isInvalid ? classes.invalid : classes.root,
          checked: this.props.isInvalid
            ? classes.invalidChecked
            : classes.checked
        }}
        onChange={this.props.onChange}
        indeterminate={this.props.isIndeter}
      />
    );

    return (
      <Wrapper {...(this.props.tooltip ? { title: this.props.tooltip } : {})}>
        {this.props.label ? (
          <FormControlLabel
            control={CheckNode}
            label={
              isString ? (
                <Typography variant="subtitle1">{this.props.label}</Typography>
              ) : (
                this.props.label
              )
            }
            labelPlacement={
              this.props.labelPlace ? this.props.labelPlace : "end"
            }
          />
        ) : (
          CheckNode
        )}
      </Wrapper>
    );
  }
}

export default withStyles(styles)(SingleCheckBox);
